import {
  Box,
  InputAdornment,
  Paper,
  SvgIcon,
  TextField
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getListVehicle,
  resetListVehicle,
  getListVehicleTrackingById
} from 'src/features/vehicleSlice';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getListAgencies } from 'src/features/agencySlice';
import { getListDeviceType } from 'src/features/deviceTypeSlice';

const CssTextField = withStyles({
  root: {
    '& .MuiInput-underline:after': {
      borderBottomColor: '#D6D9DB'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#D6D9DB'
      },
      '&:hover fieldset': {
        borderColor: '#D9042F'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#D9042F'
      }
    }
  }
})(TextField);

const ToolBar = ({ fetchData, fetchDataByUserId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const defaultFilter = {
    agency_id: ''
  };
  const [filterFormValue, setFilterFormValue] = useState(defaultFilter);
  const [searchQuery, setSearchQuery] = useState({ license_plate: '' });
  const listAgencies = useSelector(state => state.agencySlice.listAgencies);
  const newListAgencies = useMemo(
    () => [
      { id: '', name: 'Đại lý' },
      ...listAgencies.map(agency => ({
        id: agency.id,
        name: agency.name
      }))
    ],
    [listAgencies]
  );

  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const isUser = useSelector(state => state.authSlice.isUser);
  const agencyId = useSelector(state => state.authSlice.agencyId);
  const adminId = useSelector(state => state.authSlice.adminId);
  const trackingId = adminId ?? agencyId;

  const listLicensePlateCamera = useSelector(
    state => state.vehicleSlice.listLicensePlateCamera
  );

  useEffect(() => {
    dispatch(getListDeviceType());
    if (isAdmin) dispatch(getListAgencies({ page_size: 1000 }));
  }, [isAdmin, isAgency]);

  const handleChangeAgency = (e, value) => {
    if (value.id === '') {
      dispatch(
        getListVehicleTrackingById({
          id: trackingId,
          data: { 
            device_type_id: [1,7] 
          }
        })
      );
      setFilterFormValue(defaultFilter);
      return;
    }
    const selectedValue = value.id;
    const filterValue = Object.assign({}, filterFormValue, {
      agency_id: selectedValue
    });
    setFilterFormValue(filterValue);
    dispatch(
      getListVehicleTrackingById({ id: value.id, data: { device_type_id: [1,7] }})
    );
  };

  const keyPress = e => {
    if (e.keyCode === 13) {
      e.preventDefault();
      const newValue = e.target.value;
      if (isAdmin) {
        dispatch(getListVehicle({ license_plate: newValue }));
      } else if (isAgency) {
        dispatch(
          getListVehicle({ license_plate: newValue, agency_id: agencyId })
        );
      }
    }
  };

  const handleChangeInput = (e, value) => {
    const queryValue =
      typeof value === 'string' ? value : e?.target?.value ?? '';

    if (e === null) {
      setSearchQuery({ license_plate: '' });
      if (isUser) {
        fetchDataByUserId();
      } else {
        fetchData();
      }
      return;
    }

    setSearchQuery({ license_plate: queryValue });

    if (isAgency) {
      dispatch(
        getListVehicle({ license_plate: queryValue, agency_id: agencyId })
      );
    } else {
      dispatch(getListVehicle({ license_plate: queryValue }));
    }
  };

  return (
    <Paper component="form" className={classes.root}>
      <Box style={{ borderRadius: '4px', marginBottom: '0px' }}>
        {listLicensePlateCamera && (
          <Autocomplete
            freeSolo
            id="free-solo-2-demo"
            size="small"
            disableClearable
            options={listLicensePlateCamera}
            inputValue={searchQuery.license_plate}
            onChange={(e, value) => handleChangeInput(e, value)}
            classes={{ option: classes.option }}
            renderInput={params => (
              <CssTextField
                {...params}
                margin="dense"
                className="input-no-fieldset"
                variant="outlined"
                placeholder="Tìm kiếm phương tiện"
                onChange={handleChangeInput}
                InputProps={{
                  ...params.InputProps,
                  style: {
                    fontSize: '14px',
                    height: '43px'
                  },
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      style={{ cursor: 'pointer' }}
                    >
                      <SvgIcon fontSize="small" color="action">
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <>
                      {searchQuery.license_plate && (
                        <InputAdornment
                          position="end"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleChangeInput(null, undefined)}
                        >
                          <SvgIcon fontSize="small" color="action">
                            <ClearIcon />
                          </SvgIcon>
                        </InputAdornment>
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }}
                onKeyDown={keyPress}
              />
            )}
          />
        )}

        <Box
          style={{
            flexDirection: 'row',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '8px',
            marginTop: '10px',
            marginBottom: '12px'
          }}
        >
          {isAdmin && (
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column ',
                width: '100%'
              }}
            >
              <Autocomplete
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                size="small"
                classes={{
                  inputRoot: classes.inputRoot,
                  input: classes.input,
                  option: classes.option
                }}
                options={newListAgencies || []}
                getOptionLabel={option => option.name || 'Tất cả đại lý'}
                value={(newListAgencies || []).find(
                  option => option.id === filterFormValue.agency_id
                )}
                onChange={handleChangeAgency}
                disableClearable
                renderInput={params => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Tất cả đại lý"
                    InputProps={{
                      ...params.InputProps,
                      style: { fontSize: '14px', textAlign: 'center', height: '40px' }
                    }}
                  />
                )}
                style={{ flex: 1 }}
                className={classes.customOutline}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'unset'
  },
  input: {
    flex: 1,
    fontSize: '14px',
    padding: '0 !important',
    paddingLeft: '8px !important'
  },
  inputRoot: {
    height: 40,
    display: 'flex',
    alignItems: 'center',

    '& .MuiOutlinedInput-notchedOutline': {
      top: 0,
    },
  },
  option: {
    fontSize: '14px',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    alignItems: 'center',

    '&:last-child': {
      borderBottom: 'none'
    }
  },
  customOutline: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#D6D9DB',
        borderWidth: 1
      },
      '&:hover fieldset': {
        borderColor: '#D9042F'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#D9042F'
      }
    }
  }
}));

export default React.memo(ToolBar);
